export default __webpack_public_path__ + "static/lframe-boat-loan-20605e7ad9bf97abc4ff41c3c67d09fd.webp";